import { useState } from 'react';
import { Grid, Box, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { Icon } from '@mui/material';
import { gridSpacing } from '../../utils/constants';
import SubCard from '../../components/Cards/SubCard';
import { toast } from 'react-toastify';

const EditVideoDialog = ({ open, onClose, reference, onUpdate, onSave, refType, onDelete, limitFields }) => {
    const [title, setTitle] = useState(reference ? reference['name'] : '');
    const [download, setdownload] = useState(reference ? reference['downloadurl'] : '');
    const [shortname, setShortname] = useState(reference ? reference['shortname'] : '');
    const [uploadFile, setUploadFile] = useState(null);
    const [errors, setErrors] = useState({});
    const [icon, setIcon] = useState(reference ? { name: reference['icon_name'], url: reference['icon_url'] } : null);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [saveConfirmOpen, setSaveConfirmOpen] = useState(false);
    const [formData, setFormData] = useState(null);

    const iconData = [
        {
            icon_name: 'windowsImg',
            icon_url: '/static/images/windows.png'
        },
        {
            icon_name: 'windowsMSIImg',
            icon_url: '/static/images/windows_msi.png'
        },
        {
            icon_name: 'macOSImg',
            icon_url: '/static/images/macOS.png'
        },
        {
            icon_name: 'applianceImg',
            icon_url: '/static/images/appliance.png'
        },
        {
            icon_name: 'txtImg',
            icon_url: '/static/images/txt.png'
        },
        {
            icon_name: 'sccmImg',
            icon_url: '/static/images/sccm.png'
        },
        {
            icon_name: 'pdfImg',
            icon_url: '/static/images/pdf.png'
        },
        {
            icon_name: 'docImg',
            icon_url: '/static/images/doc.png'
        },
        {
            icon_name: 'movieImg',
            icon_url: '/static/images/movie.png'
        },
        {
            icon_name: 'floppyImg',
            icon_url: '/static/images/floppydisk.png'
        }
    ];

    const validate = (formData) => {
        const newErrors = {};
        if (formData.get('name') === 'undefined') {
            newErrors.name = 'Name is required';
        }
        if (formData.get('shortname') === 'undefined') {
            newErrors.shortname = 'Shortname is required';
        }
        if (formData.get('download') === 'undefined' && refType == 'Video') {
            newErrors.download = 'Download is required';
        }
        if (formData.get('icon_name') === 'undefined') {
            newErrors.icon = 'Icon is required';
        }

        if (formData.get('uploadFile') === 'null' && refType != 'Video' && !reference['id']) {
            newErrors.uploadFile = 'Upload is required';
        }
        return newErrors;
    };

    const handleSave = () => {
        setErrors({});
        const newFormData = new FormData();
        newFormData.append('name', title);
        newFormData.append('shortname', shortname);
        newFormData.append('download', download);
        newFormData.append('icon_name', icon['name']);
        newFormData.append('icon_url', icon['url']);
        if (refType !== 'Video') {
            newFormData.append('uploadFile', uploadFile);
        }

        const validationErrors = validate(newFormData);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        // If it's an update and a new file is selected, show confirmation
        if (reference['id'] && uploadFile && refType !== 'Video') {
            setFormData(newFormData);
            setSaveConfirmOpen(true);
        } else {
            // For new items or updates without file change, proceed directly
            if (Object.keys(reference || {}).length === 0) onSave(newFormData);
            else onUpdate(newFormData);
        }
    };

    const handleSaveConfirm = () => {
        setSaveConfirmOpen(false);
        onUpdate(formData);
    };

    const handleIconSelect = (e) => {
        const icon = iconData.find((icon) => icon['icon_name'] == e.target.alt);
        setIcon({
            name: icon['icon_name'],
            url: icon['icon_url']
        });
    };

    const handleDelete = () => {
        setDeleteConfirmOpen(true);
    };

    const handleDeleteConfirm = () => {
        setDeleteConfirmOpen(false);
        onDelete();
    };

    const handleChangeTitle = (e) => {
        if (e.target.value.length > limitFields['title']) {
            toast.warning('This field must be ' + limitFields['title'] + ' characters or less.');
        } else {
            setTitle(e.target.value);
        }
    };

    const handleChangeName = (e) => {
        if (e.target.value.length > limitFields['shortname']) {
            toast.warning('This field must be ' + limitFields['shortname'] + ' characters or less.');
        } else {
            setShortname(e.target.value);
        }
    };

    const handleChangeUrl = (e) => {
        if (e.target.value.length > limitFields['url']) {
            toast.warning('This field must be ' + limitFields['url'] + ' characters or less.');
        } else {
            setdownload(e.target.value);
        }
    };

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontSize: '16px' }}>Edit {refType} Reference</DialogTitle>
                <DialogContent>
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={6}>
                            <TextField fullWidth label="Title" value={title} onChange={(e) => handleChangeTitle(e)} margin="normal" />
                            {errors.name && <p style={{ color: 'red' }}>{errors.name}</p>}
                            <TextField fullWidth label="Name" value={shortname} onChange={(e) => handleChangeName(e)} margin="normal" />
                            {errors.shortname && <p style={{ color: 'red' }}>{errors.shortname}</p>}
                            {refType == 'Video' ? (
                                <>
                                    <TextField
                                        fullWidth
                                        label="Url"
                                        value={download}
                                        onChange={(e) => handleChangeUrl(e)}
                                        margin="normal"
                                    />
                                    {errors.download && <p style={{ color: 'red' }}>{errors.download}</p>}
                                </>
                            ) : (
                                <>
                                    {reference['folder'] ? <p>Uploaded File: {reference['folder'].split('/').pop()}</p> : ''}
                                    <input
                                        accept="all/*"
                                        type="file"
                                        onChange={(e) => setUploadFile(e.target.files[0])}
                                        style={{ marginTop: 20 }}
                                    />
                                    {errors.uploadFile && <p style={{ color: 'red' }}>{errors.uploadFile}</p>}
                                </>
                            )}
                        </Grid>
                        <Grid item xs={6} sx={{ textAlign: 'center' }}>
                            <SubCard title="Icon">
                                <Grid container>
                                    {iconData.map((row, key) => (
                                        <Grid item xs={2} key={key}>
                                            <div
                                                style={{
                                                    position: 'relative',
                                                    width: '100%',
                                                    aspectRatio: '1 / 1' // Maintains 1:1 ratio
                                                }}
                                            >
                                                {icon['name'] === row.icon_name && (
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: 4,
                                                            right: 4,
                                                            zIndex: 2,
                                                            backgroundColor: 'rgba(181,194,81,0.8)',
                                                            borderRadius: '50%',
                                                            padding: '4px'
                                                        }}
                                                    >
                                                        <Icon fontSize="small" color="primary">
                                                            &#10003;
                                                        </Icon>
                                                    </div>
                                                )}
                                                <Box onClick={handleIconSelect}>
                                                    <img
                                                        src={row.icon_url}
                                                        alt={row.icon_name}
                                                        style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'contain'
                                                        }}
                                                    />
                                                </Box>
                                            </div>
                                        </Grid>
                                    ))}
                                </Grid>
                            </SubCard>
                            {errors.icon && <p style={{ color: 'red' }}>{errors.icon}</p>}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button onClick={handleSave} color="primary">
                        Save
                    </Button>
                    {reference['id'] ? (
                        <Button onClick={handleDelete} color="error">
                            Delete
                        </Button>
                    ) : (
                        ''
                    )}
                </DialogActions>
            </Dialog>

            <Dialog
                open={deleteConfirmOpen}
                onClose={() => setDeleteConfirmOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this {refType} reference?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteConfirmOpen(false)}>Cancel</Button>
                    <Button onClick={handleDeleteConfirm} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={saveConfirmOpen}
                onClose={() => setSaveConfirmOpen(false)}
                aria-labelledby="save-alert-dialog-title"
                aria-describedby="save-alert-dialog-description"
            >
                <DialogTitle id="save-alert-dialog-title">Confirm Update</DialogTitle>
                <DialogContent>
                    <DialogContentText id="save-alert-dialog-description">
                        You have selected a new file to upload. This will replace the existing file. Do you want to continue?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setSaveConfirmOpen(false)}>Cancel</Button>
                    <Button onClick={handleSaveConfirm} color="primary">
                        Update
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

EditVideoDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    reference: PropTypes.object,
    onUpdate: PropTypes.func,
    onSave: PropTypes.func,
    onDelete: PropTypes.func,
    refType: PropTypes.string,
    limitFields: PropTypes.object
};

export default EditVideoDialog;
